import { useMutation, useQuery, useQueryClient } from "react-query"
import { deleteUnbillableCategory, getUnbillableCategories, updateUnbillableCategory } from "./unbillableCategoriesApi"
import { UnbillableCategory } from "./unbillableCategory"

export const useUnbillableCategories = () => {
  return useQuery({
    queryKey: ['unbillable-categories'],
    queryFn: getUnbillableCategories,
    refetchOnWindowFocus: false
  })
}

export const useUnbillableCategoriesInvalidator = () => {
  const queryClient = useQueryClient()

  return {
    invalidate: () => queryClient.invalidateQueries('unbillable-categories')
  }
}

export const useUpdateUnbillableCategory = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateUnbillableCategory,
    onMutate: async (unbillableCategory: UnbillableCategory) => {
      queryClient.setQueryData(['unbillable-categories'], (oldData: any) => {
        return oldData.map((oldUnbillableCategory: any) => {
          if (oldUnbillableCategory.id === unbillableCategory.id) {
            return unbillableCategory
          }
          return oldUnbillableCategory
        })
      })
    },
    onSettled: () => queryClient.invalidateQueries('unbillable-categories')
  })
}

export const useDeleteUnbillableCategory = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteUnbillableCategory,
    onSettled: () => queryClient.invalidateQueries('unbillable-categories')
  })
}
